import type { CSSProperties } from 'react';
import { sidebarConfig } from '@backstage/core-components';

export const sidebarCssVars = {
  '--sidebar-width-open': `${sidebarConfig.drawerWidthOpen}px`,
  '--sidebar-width-closed': `${sidebarConfig.drawerWidthClosed}px`,
  '--sidebar-height': `${3 * sidebarConfig.logoHeight}px`,
} as CSSProperties;
